import type { CreateSubsidiaryRequestPayload, CreateSubsidiaryResponse } from '@vy/api-definition';
import { CreateSubsidiaryResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useCreateSubsidiary(
  options?: UseMutationOptions<CreateSubsidiaryResponse, unknown, CreateSubsidiaryRequestPayload>,
) {
  return useMutation({
    mutationFn: async ({ subsidiary }) => {
      const api = getPrivateApi();

      const createSubsidiaryResponse = await api.createSubsidiary({
        createSubsidiaryRequest: { subsidiary },
      });

      return CreateSubsidiaryResponseSchema.parse(createSubsidiaryResponse);
    },
    ...options,
  });
}
